import React from "react";
import { QuickPayType } from "store/config";
import { ItemBar, BarItems } from "components/common/itemBar/ItemBar";

export enum QuickPayStep {
  Info = "info",
  Payment = "payment",
  Review = "review",
}

export interface QuickPayBarTitles {
  loan: string;
  information: string;
  payment: string;
  review: string;
  complete: string;
}

interface QuickPayBarProps {
  progress: string;
  quickPayType: QuickPayType;
  titles: QuickPayBarTitles;
  activeStep: QuickPayStep;
}

const STEP_ICONS: [string, string, string, string] = [
  "receipt_long",
  "payments",
  "grading",
  "verified",
];

const STEP_INDEX: Record<QuickPayStep, number> = {
  [QuickPayStep.Info]: 0,
  [QuickPayStep.Payment]: 1,
  [QuickPayStep.Review]: 2,
};

const buildQuickPayBarItems = (
  quickPayType: QuickPayType,
  titles: QuickPayBarTitles,
  activeStep: QuickPayStep,
): BarItems[] => {
  const active = STEP_INDEX[activeStep];
  const firstTitle =
    quickPayType === QuickPayType.NonValidated
      ? titles.information
      : titles.loan;
  const allTitles = [
    firstTitle,
    titles.payment,
    titles.review,
    titles.complete,
  ];

  return allTitles.map((title, i) => ({
    title,
    icon: STEP_ICONS[i],
    ...(i === active && { isSelected: true }),
    ...(i < active && { isVisited: true }),
  }));
};

export const QuickPayBar: React.FC<QuickPayBarProps> = ({
  progress,
  quickPayType,
  titles,
  activeStep,
}) => {
  const items = buildQuickPayBarItems(quickPayType, titles, activeStep);
  return <ItemBar items={items} progress={progress} />;
};
